<template>
  <div class="page">
    <BACK title="帳號個人資料"/>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="真實姓名/公司行號" prop="name">
        <el-input type="text" maxlength="255" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="暱稱" prop="nickname">
        <el-input v-model="form.nickname" type="text" maxlength="255" clearable ></el-input>
      </el-form-item>
      <!-- <el-form-item label="統一編號" prop="businessNo">
        <el-input v-model="form.businessNo" oninput="value=value.replace(value.slice(14),'')" type="number" clearable placeholder="輸入公司統一編號"></el-input>
      </el-form-item>
      <el-form-item prop="licence">
        <div slot="label" class="uploader_tit">上傳圖片<span>(個人請上傳駕照,公司請上傳營業登記證)</span></div>
        <el-upload
          class="avatar-uploader"
          action="/api/file/image/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="form.licence" :src="form.licence" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item> -->
    </el-form>
    <div class="btn">
      <el-button type="success" :disabled="loading" @click="handleSubmit"><i class="el-icon-loading" v-if="loading"></i>送出</el-button>
    </div>
  </div>
</template>
<script>

import BACK from '@/components/back.vue'
import FN from '@/components/fn'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserSet',
  components: {
    BACK
  },
  mixins: [FN],
  data() {
    return {
        imageUrl: "",
        form:{
          name: '',
          nickname: '',
          businessNo: '',
          licence: '',
        }
    }
  },
  mounted() {
    //取得資料並寫入
    this.getUserInfo()
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    rules() {
        const message = '輸入不完整'
        // 自訂驗證-phone
        const isPhone = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(length !== 10){
            callback(new Error('輸入錯誤，請輸入10位元電話號碼'))
          }else if(value.slice(0, 2) !== '09'){
            callback(new Error('輸入錯誤，請輸入09開頭之電話號碼'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password
        const isPassword = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(length < 8 || length > 14){
            callback(new Error('輸入錯誤，請輸入8-14位元'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password2
        const isPassword2 = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(value !== this.form.password){
            callback(new Error('兩次輸入的密碼不同'))
          }else{
            callback()
          }
        }
        return {
            name: [
                { required: true, trigger: 'blur', message }
            ],
            nickname: [
                { required: true, trigger: 'blur', message }
            ],
            // businessNo: [
            //     { required: true, trigger: 'blur', message }
            // ],
            // licence: [
            //     { required: true, trigger: 'blur', message }
            // ]
        }
    }
  },
  methods: {
    ...mapActions([
      'FETCH'
    ]),
    //送出表單
    handleSubmit() {
      const form = this.$refs.form
      this.beforeValidate()
      form.validate((valid) => {
        if (valid) {
            this.loading = true
            this.beforeFormSubmit()
            this.FETCH({
              key: 'MODIFY',
              name: this.form.name,
              nickname: this.form.nickname
            })
            .then((this.handleResponse))
        } else {
            this.loading = false
            this.handleUnValid()
        }
      })

    },
    //回應
    handleResponse(res) {
      if (!+res.code) {
        this.$confirm('個人資料設定成功',{
          showCancelButton: false,
          type: 'success'
        })
          .then(() => {
            const { href } = this.$router.resolve({name: 'SetList'})
            window.open(href, '_self')
          })
      }else{
        this.$confirm(res.message,{
          showCancelButton: false,
          type: 'error'
        })
      }
      this.loading = false
    },
    handleAvatarSuccess(res, file) {
      this.form.licence = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === 'image/png';
      const isJPG = file.type === 'image/jpeg';
      const isSVG = file.type === 'image/svg+xml';
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!(isJPG || isPNG || isSVG)) {
        this.$message.error('上传头像图片只能是 JPG/PNG/SVG 格式!');
        return true
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 3MB!');
        return true
      }
      return (isJPG || isPNG || isSVG) && isLt2M;
    },
    getUserInfo() {
      this.FETCH({
        key: 'USER_INFO',
      }).then((res) => {
        //需要accToken的驗證
        if(+(res || {}).code === -3){
          this.checkNewToken(this.getUserInfo)
        }
        //有成功的話寫入
        if(!+(res || {}).code){
          this.form = {
              ...this.form,
              ...this.userInfo
          }
        }
      })
    },
    handleBack() {
      const { href } = this.$router.resolve({name: 'SetList'})
      window.open(href, '_self')
    }
  }
}
</script>
